import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProcessAccountLedgersMutationVariables = Types.Exact<{
  account_ledgers: Array<Types.AccountLedgerInput> | Types.AccountLedgerInput;
}>;


export type ProcessAccountLedgersMutation = { __typename?: 'Mutation', processAccountLedgers: { __typename?: 'ProcessAccountLedgersResult', created_count: number, invoice_linked_count: number, processed_count: number, updated_count: number, results: Array<{ __typename?: 'ProcessAccountLedgerResult', id: string, billomat_invoice_matched: boolean, billomat_invoice_was_already_linked: boolean, match_log: string, store_id?: string | null, was_already_existing: boolean, was_created: boolean, was_updated: boolean, store?: { __typename?: 'Store', id: string, name?: string | null } | null }> } };


export const ProcessAccountLedgersDocument = gql`
    mutation ProcessAccountLedgers($account_ledgers: [AccountLedgerInput!]!) {
  processAccountLedgers(account_ledgers: $account_ledgers) {
    created_count
    invoice_linked_count
    processed_count
    updated_count
    results {
      id
      billomat_invoice_matched
      billomat_invoice_was_already_linked
      match_log
      store_id
      store {
        id
        name
      }
      was_already_existing
      was_created
      was_updated
    }
  }
}
    `;
export type ProcessAccountLedgersMutationFn = Apollo.MutationFunction<ProcessAccountLedgersMutation, ProcessAccountLedgersMutationVariables>;

/**
 * __useProcessAccountLedgersMutation__
 *
 * To run a mutation, you first call `useProcessAccountLedgersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessAccountLedgersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processAccountLedgersMutation, { data, loading, error }] = useProcessAccountLedgersMutation({
 *   variables: {
 *      account_ledgers: // value for 'account_ledgers'
 *   },
 * });
 */
export function useProcessAccountLedgersMutation(baseOptions?: Apollo.MutationHookOptions<ProcessAccountLedgersMutation, ProcessAccountLedgersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessAccountLedgersMutation, ProcessAccountLedgersMutationVariables>(ProcessAccountLedgersDocument, options);
      }
export type ProcessAccountLedgersMutationHookResult = ReturnType<typeof useProcessAccountLedgersMutation>;
export type ProcessAccountLedgersMutationResult = Apollo.MutationResult<ProcessAccountLedgersMutation>;
export type ProcessAccountLedgersMutationOptions = Apollo.BaseMutationOptions<ProcessAccountLedgersMutation, ProcessAccountLedgersMutationVariables>;